import Vue from "vue";

import Vuetify, {
    VApp,
    VAvatar,
    VBtn,
    VCard,
    VCheckbox,
    VChip,
    VDialog,
    VDivider,
    VFooter,
    VIcon,
    VInput,
    VList,
    VNavigationDrawer,
    VProgressCircular,
    VProgressLinear,
    VSelect,
    VSnackbar,
    VSubheader,
    VSwitch,
    VTabs,
    VTextarea,
    VTextField,
    VToolbar,
    VContent,
    VContainer,
    VFlex,
    VLayout,
    VSpacer,
    VLabel,
    VToolbarSideIcon,
    VListTile,
    VListTileAction,
    VListTileAvatar,
    VListTileContent,
    VListTileTitle,
    VListTileSubTitle,
    VMenu,
    VCarousel,
    VCarouselItem,
} from "vuetify/lib";

import {
    Ripple,
    Touch,
} from "vuetify/lib/directives";

export const setupVuetify = () => {
    Vue.use(Vuetify, {
        components: {
            VApp,
            VAvatar,
            VBtn,
            VCard,
            VCheckbox,
            VChip,
            VDialog,
            VDivider,
            VFooter,
            VIcon,
            VInput,
            VList,
            VNavigationDrawer,
            VProgressCircular,
            VProgressLinear,
            VSelect,
            VSnackbar,
            VSubheader,
            VSwitch,
            VTabs,
            VTextarea,
            VTextField,
            VToolbar,
            VContent,
            VContainer,
            VFlex,
            VLayout,
            VSpacer,
            VLabel,
            VToolbarSideIcon,
            VListTile,
            VListTileAction,
            VListTileAvatar,
            VListTileContent,
            VListTileTitle,
            VListTileSubTitle,
            VMenu,
            VCarousel,
            VCarouselItem,
        },
        directives: {
            Ripple,
            Touch,
        },
    });
}

import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader